import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";
import apiClient from "api-client";

export const useCreateBillingNotesMutation = getWrappedUseMutation(apiClient.BillingNotes.post);

export const useDeleteBillingNotesMutation = getWrappedUseMutation(apiClient.BillingNotes.delete);
